import { useContext, useEffect, useState } from "react";
import { FaGreaterThan } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AlertContext from "../../../context/Alert/AlertContext";
import AuthContext from "../../../context/Auth/AuthContext";
import axiosPrivate from "../../../hooks/axiosPrivate";
import "../Logistic/logistic.css";
import LoaderContext from "../../../context/loader/LoaderContext";
import { showErrorToast, showSuccessToast } from "../../../Toster";
import "../Account/invoice.css";
import "./Dispatch.module.css";
import { BiEdit } from "react-icons/bi";
import { FiEye } from "react-icons/fi";
import styles from "../Logistic/Logistic.module.css";
import { Dialog } from "primereact/dialog";
import ViewOrderInvoice from "./ViewInvoice";
import SplitedOrders from "./SpiltedOrders";
import MergedOrders from "./MergeOrders";
import MarkedGenerated from "./MarkedGenerated";

const selectedItemInitialValue = {
  type: "",
  groupName: "",
  splitId: [],
};

const initalDiscountValues = {
  name: "",
  value: "",
  type: "percentage",
};

const Dispatch = () => {
  const { setIsLoading } = useContext(LoaderContext);
  const { authPermissions } = useContext(AuthContext);
  const { alertMessage, setAlertMessage } = useContext(AlertContext);
  const [dealerWiseData, setDealerWiseData] = useState([]);
  const navigate = useNavigate();
  const [isPreview, setIsPreview] = useState(false);
  const [openInvoice, setOpenInvoice] = useState(false);
  const [discountValues, setDiscountValues] = useState(initalDiscountValues);
  const [invoiceData, setInvoiceData] = useState(null);
  const [openMarkedModel, setOpenMarkedModal] = useState(false);

  useEffect(() => {
    // if (!authPermissions.includes("Account-List")) {
    //   navigate("/admin/dashboard");
    // }
    setIsLoading(true);
    axiosPrivate
      .get("dispatch/list/items")
      .then((response) => {
        const groupedByDealer = {};

        response?.data?.data.forEach((group) => {
          const allItems = [
            ...group.splited_group_items,
            ...group.merged_group_items.flatMap(({ merge_id, group_items }) =>
              group_items.map((item) => ({
                ...item,
                merge_id,
              }))
            ),
          ];

          allItems.forEach((item) => {
            if (!groupedByDealer[item.name]) {
              groupedByDealer[item.name] = {
                dealer_name: item.name,
                locations: {},
              };
            }

            if (!groupedByDealer[item.name].locations[group.group_name]) {
              groupedByDealer[item.name].locations[group.group_name] = {
                splited: [],
                merged: [],
              };
            }

            const orderType = item?.merge_id ? "merged" : "splited";

            groupedByDealer[item.name].locations[group.group_name][
              orderType
            ].push(item);
          });
        });

        setDealerWiseData(groupedByDealer);
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }, [authPermissions]);

  // useEffect(() => {
  //   var acc = document.getElementsByClassName('accordion-custome');
  //   var i;

  //   for (i = 0; i < acc.length; i++) {
  //     acc[i].addEventListener('click', function () {
  //       this.classList.toggle('active-custome');
  //       var panel = this.nextElementSibling;
  //       if (panel.style.display === 'block') {
  //         panel.style.display = 'none';
  //       } else {
  //         panel.style.display = 'block';
  //       }
  //     });
  //   }
  // }, [logistics]);

  //State For selected items start
  const [selectedItems, setSelectedItems] = useState(selectedItemInitialValue);
  const [mergerButton, setMergerButton] = useState(false);
  //State for selected items end
  //State For Merge Modal end

  useEffect(() => {
    if (alertMessage != null) {
      toast(alertMessage.message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      setAlertMessage(null);
    }
  }, [alertMessage]);

  //Function to handle and add selected id start
  const selectItems = async (event, id, groupName, orderId, type) => {
    setSelectedItems((prev) => {
      if (prev.groupName === groupName) {
        const ids = prev.splitId.includes(id)
          ? prev.splitId.filter((item) => item !== id)
          : [...prev.splitId, id];

        return ids.length === 0
          ? { groupName: "", splitId: [] }
          : { ...prev, splitId: ids };
      }

      return { groupName, type, splitId: [id] };
    });
  };

  //Function to handle and add selected id end

  //Function to remove the selected items start
  const removeSelectedItems = () => {
    //Loop and remove checked items start
    document.querySelectorAll(".select-merge").forEach(function (checkBox) {
      checkBox.checked = false;
    });
    //Loop and remove checked items end

    setSelectedItems([]);
    setMergerButton(false);
    return true;
  };
  //Function to remove the selected items end

  //Merge Close Modal function end

  //Function to handle modal form submission end

  var acc = document.getElementsByClassName("accordion-custome");
  var i;

  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function () {
      this.classList.toggle("active-custome");
      var panel = this.nextElementSibling;
      if (panel.style.display === "block") {
        panel.style.display = "none";
      } else {
        panel.style.display = "block";
      }
    });
  }

  /* Function to reset state of logistic after invoice genrate */
  const resetLogisticState = async () => {
    await axiosPrivate.get("dispatch/list/items").then((response) => {
      const groupedByDealer = {};

      response?.data?.data.forEach((group) => {
        const allItems = [
          ...group.splited_group_items,
          ...group.merged_group_items.flatMap(({ merge_id, group_items }) =>
            group_items.map((item) => ({
              ...item,
              merge_id,
            }))
          ),
        ];

        allItems.forEach((item) => {
          if (!groupedByDealer[item.name]) {
            groupedByDealer[item.name] = {
              dealer_name: item.name,
              locations: {},
            };
          }

          if (!groupedByDealer[item.name].locations[group.group_name]) {
            groupedByDealer[item.name].locations[group.group_name] = {
              splited: [],
              merged: [],
            };
          }

          const orderType = item?.merge_id ? "merged" : "splited";

          groupedByDealer[item.name].locations[group.group_name][
            orderType
          ].push(item);
        });
      });

      setDealerWiseData(groupedByDealer);
    });
  };

  /* Function to handle dispatch button  */
  const handleDispatchButton = async (
    event,
    orderId,
    splitId = null,
    mergeId = null
  ) => {
    const currentLogedInUserId = JSON.parse(
      localStorage.getItem("userDetails")
    );
    let user_id = currentLogedInUserId.id;
    event.preventDefault();
    setIsLoading(true);
    axiosPrivate
      .post("dispatch/update-order-status", {
        orderId: orderId,
        splitId: splitId,
        mergeId: mergeId,
        status: "1",
        user_id: user_id,
      })
      .then(async (response) => {
        if (response.status === 201) {
          setAlertMessage({ message: response.message });
          await resetLogisticState();
        }
        setIsLoading(false);
      })
      .catch(async (error) => {
        setIsLoading(false);
      });
  };

  /* Function to handle dispatch button  */
  const handleDeliverButton = async (
    event,
    orderId,
    splitId = null,
    mergeId = null
  ) => {
    const currentLogedInUserId = JSON.parse(
      localStorage.getItem("userDetails")
    );
    let user_id = currentLogedInUserId.id;
    event.preventDefault();
    setIsLoading(true);
    axiosPrivate
      .post("dispatch/deliever/update-order-status", {
        orderId: orderId,
        splitId: splitId,
        mergeId: mergeId,
        status: "1",
        user_id: user_id,
      })
      .then(async (response) => {
        if (response.status === 201) {
          setAlertMessage({ message: response?.data?.message });
          await resetLogisticState();
        }
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
      });
  };

  function formatDate(inputDate) {
    const months = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec",
    ];

    const date = new Date(inputDate);
    const day = date.getUTCDate();
    const month = months[date.getUTCMonth()];
    const year = date.getUTCFullYear();

    return `${day} ${month} ${year}`;
  }

  const generateInvoice = async (data) => {
    setIsLoading(true);
    await axiosPrivate
      .post("accounting/generate/invoice", {
        ...data,
        godown_id: "2f7a93e9-1fc4-11ee-9c9b-b02628e88184",
      })
      .then(async (response) => {
        setIsLoading(false);
        if (response.status == 201) {
          await response?.data?.invoice?.forEach((item) => {
            let total_quantity = 0;

            // Extract quantities, convert to numbers, and sum them up
            total_quantity = item?.products?.reduce((acc, product) => {
              return acc + Number(product?.quantity);
            }, 0);
            item.quantity = total_quantity;
          });

          setOpenInvoice(false);
          showSuccessToast("Invoice generated successfully");
          setSelectedItems(selectedItemInitialValue);
          await resetLogisticState();
        }
        if (response.status == 200) {
          showErrorToast(response?.data?.message);
        }

        if (response.status == 500) {
          setIsLoading(false);
          setOpenInvoice(false);
          showErrorToast("Server Issue please try after some time");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setOpenInvoice(false);
        setDiscountValues(initalDiscountValues);
        showErrorToast(err?.response?.data?.message);
      });
  };

  const markGenerateInvoice = async (data) => {
    setIsLoading(true);
    await axiosPrivate
      .post("accounting/mark/generate/invoice", {
        ...data,
        godown_id: "2f7a93e9-1fc4-11ee-9c9b-b02628e88184",
      })
      .then(async (response) => {
        setIsLoading(false);
        if (response.status == 201) {
          await response?.data?.invoice?.forEach((item) => {
            let total_quantity = 0;

            // Extract quantities, convert to numbers, and sum them up
            total_quantity = item?.products?.reduce((acc, product) => {
              return acc + Number(product?.quantity);
            }, 0);
            item.quantity = total_quantity;
          });

          setOpenInvoice(false);
          showSuccessToast("Invoice marked generated successfully");
          setSelectedItems(selectedItemInitialValue);
          await resetLogisticState();
        }
        if (response.status == 200) {
          showErrorToast(response?.data?.message);
        }

        if (response.status == 500) {
          setIsLoading(false);
          setOpenInvoice(false);
          showErrorToast("Server Issue please try after some time");
        }
      })
      .catch((err) => {
        setIsLoading(false);
        setOpenInvoice(false);
        setDiscountValues(initalDiscountValues);
        showErrorToast(err?.response?.data?.message);
      });
  };

  const handleButtonClick = (event, orders, buttonStatus) => {
    const filterOrders = orders.filter((order) =>
      selectedItems.splitId.includes(order.split_id)
    );
    filterOrders.forEach((order) => {
      if (order?.dispatch_status === 0 && buttonStatus === "dispatch") {
        handleDispatchButton(
          event,
          order?.order_id,
          order?.split_id,
          order?.merge_id
        );
      }
      if (
        order?.delivered_status === 0 &&
        order?.dispatch_status === 1 &&
        buttonStatus === "deliver"
      ) {
        handleDeliverButton(
          event,
          order?.order_id,
          order?.split_id,
          order?.merge_id
        );
      }
    });
  };

  const genrateInvoiceModal = (data) => {
    setInvoiceData(data);
    setIsPreview(true);
  };

  const genrateMarkedInvoiceModal = (data) => {
    setInvoiceData(data);
    setOpenMarkedModal(true);
  }

  const submitDiscount = () => {
    setInvoiceData((prev) => ({
      ...prev,
      discount: { ...discountValues, value: Number(discountValues.value) },
    }));
    setIsPreview(false);
    setOpenInvoice(true);
  };

  const handleGenerate = () => {
    const type = selectedItems.type;

    const orders = invoiceData?.orders || [];
    const discount = invoiceData?.discount || null;

    const filterOrders = orders.filter((order) =>
      selectedItems.splitId.includes(order.split_id)
    );

    if (type === "split") {
      const orders = filterOrders.map((order) => ({
        order_id: order.order_id,
        split_id: order.split_id,
      }));
      const data = {
        orders,
        type,
        discount,
      };
      generateInvoice(data);
    } else if (type === "merge") {
      const orders = filterOrders.map((order) => ({
        order_id: order.order_id,
        merge_id: order.merge_id,
      }));
      const data = {
        orders,
        type,
        discount,
      };
      generateInvoice(data);
    }
  };

  const handleMarkedGenerate = (voucherNumber) => {
    const type = selectedItems.type;
    console.log("selectedItems", selectedItems);
    const orders = invoiceData?.orders || [];
    const discount = invoiceData?.discount || null;

    const filterOrders = orders.filter((order) =>
      selectedItems.splitId.includes(order.split_id)
    );

    if (type === "split") {
      const orders = filterOrders.map((order) => ({
        order_id: order.order_id,
        split_id: order.split_id,
      }));
      const data = {
        orders,
        type,
        discount,
        vch_no: voucherNumber,
      };
      markGenerateInvoice(data);
    } else if (type === "merge") {
      const orders = filterOrders.map((order) => ({
        order_id: order.order_id,
        merge_id: order.merge_id,
      }));
      const data = {
        orders,
        type,
        discount,
        vch_no: voucherNumber,
      };
      markGenerateInvoice(data);
    }
  };

  return (
    <>
      <div className="section-body">
        <Dialog
          header="Add Discount"
          visible={isPreview}
          onHide={() => {
            setDiscountValues(initalDiscountValues);
            if (!isPreview) return;
            setIsPreview(false);
          }}
          style={{ minHeight: "350px" }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              width: "100%",
              padding: "0 10px",
            }}
          >
            <div className="">
              <label>
                Discount Name<span className="required">*</span>
              </label>
              <select
                className="form-control"
                value={discountValues.name}
                onChange={(event) => {
                  setDiscountValues((prev) => ({
                    ...prev,
                    name: event.target.value,
                    type:
                      event.target.value === "Discount"
                        ? "amount"
                        : "percentage",
                  }));
                }}
              >
                <option value="">Select Discount Name</option>
                <option value="Discount">Discount</option>
                <option value="Single Lifting Discount">
                  Single Lifting Discount
                </option>
              </select>
            </div>
            <div className="">
              <label>
                Discount {discountValues.type === "percentage" ? "%" : "₹"}
                <span className="required">*</span>
              </label>
              <input
                type="number"
                className="form-control"
                placeholder="Enter Discount Rate"
                value={discountValues.value}
                onChange={(event) => {
                  setDiscountValues((prev) => ({
                    ...prev,
                    value: event.target.value,
                  }));
                }}
              />
            </div>
            <div className="" style={{ textAlign: "right" }}>
              <button
                onClick={() => {
                  if (discountValues.name && discountValues.value) {
                    submitDiscount();
                  }
                }}
                disabled={!discountValues.name || !discountValues.value}
                className="btn btn-success ml-1"
              >
                Apply Discount
              </button>
              <button
                onClick={() => {
                  setIsPreview(false);
                  setOpenInvoice(true);
                  setInvoiceData((prev) => ({ ...prev, discount: null }));
                }}
                className="btn btn-success ml-1 deliver-css"
              >
                Skip
              </button>
            </div>
          </div>
        </Dialog>
        <MarkedGenerated
          onSubmit={handleMarkedGenerate}
          isPreview={openMarkedModel}
          setIsPreview={setOpenMarkedModal}
        />
        <Dialog
          header="View Invoice"
          visible={openInvoice}
          style={{ width: "80vw% !important", height: "75vh% !important" }}
          onHide={() => {
            setDiscountValues(initalDiscountValues);
            if (!openInvoice) return;

            setOpenInvoice(false);
          }}
          className={styles.dialogModel}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              gap: "24px",
              width: "100%",
            }}
          >
            <div className="">
              {invoiceData ? (
                <ViewOrderInvoice passData={invoiceData} />
              ) : (
                <p>Loading...</p> // Show a fallback UI if data is missing
              )}
            </div>

            <div
              className=""
              style={{ textAlign: "right", marginBottom: "24px" }}
            >
              <button
                onClick={() => {
                  setOpenInvoice(false);
                  setIsPreview(true);
                }}
                className="btn btn-success ml-1"
              >
                Back
              </button>
              <button onClick={handleGenerate} className="btn btn-success ml-1">
                Generate Invoice
              </button>
            </div>
          </div>
        </Dialog>
        <div className="container-fluid">
          <div className="card-header">
            <strong className="top-left-heading">Dispatched</strong>

            <ol className="headerroutes breadcrumb m-0 bg-none ">
              <li className="item color-gray">|</li>
              <li className="item">
                <Link to="/admin/dashboard" className="route-heading item mx-2">
                  Dashboard
                </Link>
              </li>
              <li className="item">
                <FaGreaterThan className="grater-than-route" />
              </li>
              <li className="route-heading item mx-2 mt-1">Dispatched</li>
            </ol>
          </div>
          <div className="tab-content ">
            <div
              className="tab-pane fade show active"
              id="user-list"
              role="tabpanel"
            >
              <div className="card">
                <div
                  className="card-body"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "12px",
                  }}
                >
                  {Object.values(dealerWiseData).map((dealer) => (
                    <div
                      key={dealer.dealer_name}
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "12px",
                      }}
                    >
                      <h4>Dealer ( {dealer.dealer_name} )</h4>
                      {Object.entries(dealer.locations).map(
                        ([location, orders]) => (
                          <div key={location}>
                            <button className="accordion-custome">
                              <div className="d-flex">
                                <span className="mr-auto p-2">
                                  Dealers Location {location}
                                </span>
                              </div>
                            </button>
                            <div className="panel1">
                              {/* Splite Items Table Start */}
                              <SplitedOrders
                                selectedItems={selectedItems}
                                setOpenMarkedGenerated={genrateMarkedInvoiceModal}
                                genrateInvoiceModal={genrateInvoiceModal}
                                orders={orders}
                                handleButtonClick={handleButtonClick}
                                selectItems={selectItems}
                                location={location}
                                handleDeliverButton={handleDeliverButton}
                              />
                              {/* Splite Items Table end */}

                              {/* Merge Items Table Start */}
                              <MergedOrders
                                selectedItems={selectedItems}
                                setOpenMarkedGenerated={genrateMarkedInvoiceModal}
                                genrateInvoiceModal={genrateInvoiceModal}
                                orders={orders}
                                handleButtonClick={handleButtonClick}
                                selectItems={selectItems}
                                location={location}
                                handleDeliverButton={handleDeliverButton}
                              />
                              {/* Merge Items Table end */}
                            </div>
                          </div>
                        )
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dispatch;
